export const CHANGE_MINI = '[NAVIGATION] CHANGE_MINI'
export const CHANGE_OPEN = '[NAVIGATION] CHANGE_OPEN'
export const CHANGE_OPEN_MOBILE = '[NAVIGATION] CHANGE_OPEN_MOBILE'
